// Modules
import axios from 'axios';
import xhr from 'modules/xhr';
import { refreshAccessToken } from 'modules/xhr/tokenRefresh';
// API
import { ENDPOINTS } from '../api.config';
import { API_URL } from 'api/api.config';
// Storage
import webStorage from 'modules/storage';
// Interfaces and types
import { IGetReportParams, TGetReportRes } from 'types/reportTypes';
import { IGetMissedCheckinsReportRes } from 'types/missedCheckinsReportTypes';
import { IGetTimeSpentOutsideGeofenceReportRes } from 'types/timeSpentOutsideGeofenceReportTypes';
import { IGetTardyReportRes } from 'types/tardyReportTypes';
import { ISignInResData } from 'types/authTypes';
import { TQueryParams } from 'types/appTypes';
// I18n
import { getCurrentLanguage } from 'i18n';

export const getReport = (params: IGetReportParams) => {
  const storageData = webStorage.getData();
  const language = getCurrentLanguage();

  return axios.get<TGetReportRes>(`${API_URL}${ENDPOINTS.reports}`, {
    headers: {
      Authorization: `Bearer ${storageData.accessToken}`,
      Accept: 'application/json',
      'Accept-Language': language,
      'Content-Type': 'application/json',
    },
    responseType: 'blob',
    params,
  });
};

export const getQuickBooksReport = (params: IGetReportParams) => {
  const storageData = webStorage.getData();
  return axios.get<TGetReportRes>(`${API_URL}/integrations/timeSheet-IIF-QBD`, {
    headers: {
      Authorization: `Bearer ${storageData.accessToken}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    responseType: 'blob',
    params,
  });
};

export const getUsageReport = () => {
  const storageData = webStorage.getData();
  const language = getCurrentLanguage();

  return axios.get<TGetReportRes>(`${API_URL}${ENDPOINTS.reports}`, {
    headers: {
      Authorization: `Bearer ${storageData.accessToken}`,
      Accept: 'application/json',
      'Accept-Language': language,
      'Content-Type': 'application/json',
    },
    responseType: 'blob',
  });
};

type TStoredSession = Omit<ISignInResData, 'tokens'> & ISignInResData['tokens'];

//* The app's one refresh (single in-flight per tab, locked across tabs); callers re-store `data`.
export const refreshToken = async () => {
  await refreshAccessToken(webStorage.getData().accessToken);

  const {
    accessToken,
    refreshToken: newRefreshToken,
    ...session
  } = webStorage.getData<TStoredSession>();
  const data: ISignInResData = {
    ...session,
    tokens: { accessToken, refreshToken: newRefreshToken },
  };

  return { data };
};

export const getTimeOutsideGeofenceReport = (params: TQueryParams) => {
  return xhr.get<IGetTimeSpentOutsideGeofenceReportRes, IGetTimeSpentOutsideGeofenceReportRes>(
    `${ENDPOINTS.reports}${ENDPOINTS.timeOutsideGeofence}`,
    { params },
  );
};

export const getMissedCheckinsReport = (params: TQueryParams) => {
  return xhr.get<IGetMissedCheckinsReportRes, IGetMissedCheckinsReportRes>(
    `${ENDPOINTS.reports}${ENDPOINTS.missedCheckins}`,
    { params },
  );
};

export const getTardyReport = (params: TQueryParams) => {
  return xhr.get<IGetTardyReportRes, IGetTardyReportRes>(
    `${ENDPOINTS.reports}${ENDPOINTS.tardyUsers}`,
    { params },
  );
};
